import { pusher } from "@common/services/socketCommution";
import React from "react";

const useCarfaxReportPaymentHandler = ({
  orderId,
  onPaymentCompletedHandler,
  onPaymentStatusHandler
}) => {

  // Handlers start...
  const onPaymentStatusListener = (e) => {
    console.log("onPaymentStatusListener", e);
    if (onPaymentStatusHandler) {
      onPaymentStatusHandler(e);
    }
    
    if (e?.intent_id === orderId && e?.status === "COMPLETED") {
      if (onPaymentCompletedHandler) {
        onPaymentCompletedHandler();
      }
    }
  }
  // Handlers end...

  // useEffect start...
  React.useEffect(() => {
    const channel = pusher.subscribe(`private-intent.${orderId}`);
    channel.bind("App\\Events\\BroadcastPaymentStatus", onPaymentStatusListener);

    return () => {
      channel.bind("App\\Events\\BroadcastPaymentStatus", onPaymentStatusListener);
    }
  }, [orderId]);
  // useEffect end...

};  

export {
  useCarfaxReportPaymentHandler
};